import { useState } from 'react'
import { Flex, Button } from 'styling/GlobalStyles'
import { BodyText, OtherText } from 'styling/Typography'
import { Badge } from 'components/Badge/Badge'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { Cell } from 'components/HonestTable/HonestTable.styled'
import { IExceptionsTabProps } from 'types/foodLogistics/foodTabProps.interface'
import { IFoodException } from 'types/foodLogistics/foodException.interface'
import { FOOD_STATUS_COLORS } from '../foodData'
import { ResolveExceptionModal } from '../components/ResolveExceptionModal'

const sevRank: Record<string, number> = { Critical: 0, High: 1, Medium: 2, Low: 3 }

export const ExceptionsTab = ({ exceptions, resolveException }: IExceptionsTabProps) => {
  const [selected, setSelected] = useState<IFoodException | null>(null)

  const sorted = [...exceptions].sort((a, b) =>
    a.status === b.status ? sevRank[a.sev] - sevRank[b.sev] : a.status === 'Open' ? -1 : 1,
  )

  const columns: IHonestTableColumn<IFoodException>[] = [
    {
      id: 'sev',
      header: 'Severity',
      sticky: true,
      minWidth: '8rem',
      cell: (e) => (
        <Cell>
          <Badge hexColor={FOOD_STATUS_COLORS[e.sev]}>
            <BodyText>{e.sev}</BodyText>
          </Badge>
        </Cell>
      ),
    },
    { id: 'type', header: 'Type', cell: (e) => <BodyText>{e.type}</BodyText> },
    { id: 'meal', header: 'Meal', cell: (e) => <BodyText>{e.meal}</BodyText> },
    { id: 'kitchen', header: 'Kitchen', cell: (e) => <BodyText>{e.kitchen}</BodyText> },
    { id: 'person', header: 'Person', cell: (e) => <BodyText>{e.person}</BodyText> },
    {
      id: 'root',
      header: 'Root Cause',
      minWidth: '18rem',
      cell: (e) => <OtherText grey>{e.root}</OtherText>,
    },
    {
      id: 'status',
      header: 'Status',
      cell: (e) => (
        <Badge hexColor={FOOD_STATUS_COLORS[e.status === 'Open' ? 'Open' : 'Resolved']}>
          <BodyText>{e.status}</BodyText>
        </Badge>
      ),
    },
    {
      id: 'action',
      header: '',
      align: 'right',
      cell: (e) =>
        e.status === 'Open' ? (
          <Button orange small onClick={() => setSelected(e)}>
            Resolve
          </Button>
        ) : (
          <OtherText grey>via {e.res}</OtherText>
        ),
    },
  ]

  return (
    <Flex column gap='1rem' width='100%'>
      <HonestTable columns={columns} data={sorted} keyField='id' />

      {selected && (
        <ResolveExceptionModal
          exception={selected}
          closeModal={() => setSelected(null)}
          onResolve={(actionKey, comment) => {
            resolveException(selected, actionKey, comment)
            setSelected(null)
          }}
        />
      )}
    </Flex>
  )
}
